/*global FB*/
/*global gapi*/
import React from 'react';

import AppConstants from 'AppConstants';
import {Button} from 'views/AppElements';
import Divider from 'muicss/lib/react/divider';
import HttpService from 'service/HttpService';
import Dispatcher from 'service/Dispatcher';

const style = {
	socialLogin: {margin: "10px", cursor: "pointer", width: "191px", height: "46px", border: "none"},
	fbConnect: {background: '#4267b2', borderRadius: "0px", display: "flex", flexDirection: "row", flexWrap: 'nowrap', margin: '10px auto', padding: '0px', bordeRadius: '2px'},
	fbIcon: {background: "white", color: "#4267b2", padding: "3px 10px", margin: "2px", border: "2px white solid",
    			borderRadius: "2px", fontSize: "200%"},
    fbText: {color: 'white', justifyContent: "center", alignItems: "center", display: "flex", 
    		height: "46px", width: "100%"},
	gmailSignIn: { background: "url('/images/login_signup/google_sign_in.png')"},

};


const FB_APP_SCOPE = 'public_profile, email';

class SocialMediaLogin extends React.Component {

	constructor(props) {
		super(props);
		this.handleFBClick = this.handleFBClick.bind(this);
		this.state = {submitting: false};
	}

	componentDidMount() {
		this.initGoogleSDK();
	}

	initGoogleSDK() {
		var handleGoogleLogin = this.handleGoogleLogin.bind(this);

		if(gapi === undefined) {
			console.log("Error: Could not download google sign in sdk");
			return;
		}
		
		gapi.load('auth2', function(){
		      // Retrieve the singleton for the GoogleAuth library and set up the client.
		      let auth2 = gapi.auth2.init({
		        client_id: AppConstants.GOOGLE_CLIENT_ID,
		        cookiepolicy: 'single_host_origin',
		      });
		  
		  	  var gmailSignInButton = document.getElementById("gmailSignIn");
		      
		      auth2.attachClickHandler(gmailSignInButton, {},
		      	handleGoogleLogin, 
		      	function(error) {
		          console.log("Error Gmail", error);
		        });
		    });
	}

	handleFBClick() {
		this.setState({submitting: true});
		
		FB.login(function(response){
			console.log("FB Login response", response);
			//this means some error occurred
			if(!response.authResponse) {
				this.setState({submitting: false});
				Dispatcher.dispatchAnAlert({message: "FB Login didn't work. Try logging in manually.", type: "ERROR"});
				return;
			}

			const accessToken = response.authResponse.accessToken;
			
			
			HttpService.loginWithFB(accessToken, function(loggedIn){
				this.setState({submitting: false});
			}.bind(this));
		}.bind(this), {scope: FB_APP_SCOPE});
	}

	handleGoogleLogin(googleUser) {
		this.setState({submitting: true});

      	const idToken = googleUser.getAuthResponse().id_token;
      	HttpService.loginWithGEmail(idToken, function(loggedIn) {
      		this.setState({submitting: false});
      	}.bind(this));
    }

	render() {
		return <div style={{textAlign: "center"}}>
			<h4 style={{fontStyle: "italic", margin: "10px 0"}}>Choose one of the options below.</h4>
			{
				this.state.submitting && <div><i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></div>
			}

			<Button id="fbLogin" style={[style.socialLogin, style.fbConnect, {'display': 'none'}]} disabled={this.state.submitting} onClick={this.handleFBClick}>
					<span style={style.fbIcon}><i className="fa fa-facebook" aria-hidden="true"></i> </span>
					<span style={style.fbText}>Login with Facebook</span>
			</Button>
			<Divider />
			<Button id="gmailSignIn" style={[style.gmailSignIn, style.socialLogin]} disabled={this.state.submitting}></Button>
		</div>
	}
}


export default SocialMediaLogin;


// WEBPACK FOOTER //
// ./src/views/user/SocialMediaLogin.js